import { AppUtils } from '../../shared/utils/index';

import { CooperationDataModel } from "../models/view/CooperationData";

export class CooperationApiService<T extends MglAppDefinition> {
	private readonly options: BasicAppOptions<T>;

	constructor(options: BasicAppOptions<T>) {
		this.options = options;
	}

	/***
	 * Submits the cooperation data to the cooperation api.
	 **/
	public submitCooperationData(model: CooperationDataModel, successCallback: (data?: any) => void, errorCallback: (jqxhr?: JQuery.jqXHR) => void): void {
		const url = T.Utils.Helper.appendURIPath(window.location.origin, this.options.app.apicooperation);

		const requestOptions = {
			method: 'POST',
			url: url,
			data: JSON.stringify(model)
		};

		AppUtils.Ajax.fragment(requestOptions, successCallback, errorCallback);
	}
}
